import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import ResultsDtoBaseModel from 'models/ResultsDtoBaseModel';

import SearchTransactionDto from "models/SearchTransactionDto";

import { RootState } from "store/store";

interface DtoState {
    resultDtoBase: ResultsDtoBaseModel;
    searchTransactionDto: SearchTransactionDto;
    getMethod?: (searchDto: SearchTransactionDto) => any;
}

const initialState: DtoState = {
    resultDtoBase: {
        totalResults: 0,
        page: 0,
        offset: 0
    },
    searchTransactionDto: {
        customerId: "",
        page: 0
    },
    getMethod: () => { }
}

export const dtosSlice = createSlice({
    name: "dtos",
    initialState,
    reducers: {
        setResultsDtoBase: (state, action: PayloadAction<ResultsDtoBaseModel>) => {
            state.resultDtoBase = action.payload;
            
        },
        setSearchDto: (state, action: PayloadAction<SearchTransactionDto>) => {
            state.searchTransactionDto = action.payload;
            
        },
        setGetMethod: (state, action: PayloadAction<(searchDto: SearchTransactionDto) => any>) => {
            state.getMethod = action.payload;
            
        },
        clearDto: (state) => {
            state = initialState;
        }
    }
});

export const selectSearchDto = (state: RootState) => state.dtos.searchTransactionDto;
export const selectResultDto = (state: RootState) => state.dtos.resultDtoBase;

export const dtosReducer = dtosSlice.reducer;
export const { setResultsDtoBase, setSearchDto, setGetMethod, clearDto } = dtosSlice.actions;